module.exports = require("lodash.isnil");